const SpanBorderBadge = ({children, ...rest}) => {
    return <span className='border me-2 px-2 my-1 rounded-2 d-flex align-items-center justify-content-between' {...rest}>{children}</span>
}

export default SpanBorderBadge;